import React from 'react';

class KeywordImprovedDeclinedBlock extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="keyword-block my-3 mx-auto">
        <div className="keyword-block-new" style={{paddingTop: "35px"}}>
          Improved: <span className="text-success">{this.props.improved}</span>
        </div>
        <div className="keyword-block-new">
          Declined: <span className="text-danger">{this.props.declined}</span>
        </div>
      </div>
    )
  }
}

export default KeywordImprovedDeclinedBlock;
